import { View } from "react-native";
import { Icon, Text, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import useDeliveryFulfillments from "../../contexts/DeliveryFulfillmentsContext";

export default function PickupSchedules() {
  const tailwind = useTailwind();
  const { pickupSchedules } = useDeliveryFulfillments();
  const { colors } = useTheme();

  if (!pickupSchedules) return null;

  if (!pickupSchedules.length) {
    return (
      <View style={tailwind("flex-row items-center gap-2")}>
        <Icon source="alert-circle-outline" size={24} color={colors.error} />
        <Text style={tailwind("flex-1")}>
          Tu dirección no se encuentra en el área de recolección.
        </Text>
      </View>
    );
  }

  return (
    <View>
      <Text variant="labelLarge">Horario de recolección</Text>
      {pickupSchedules.map(({ schedule }, index) => (
        <Text variant="bodyMedium" key={index}>
          {schedule}
        </Text>
      ))}
    </View>
  );
}
